{
    "realm": "proff-niva4",
    "url": "http://localhost:8888/auth",
    "clientId": "KoboPublicClient"
}
